import z from "zod";

export const SortSchema = z.object({
  id: z.enum(["name", "slug", "createdAt"]),
  desc: z.boolean(),
});
